// extracted by mini-css-extract-plugin
export var textInput = "_ci-0";